<template lang="pug">
    div.packagesWrapper
        div.packagesOverlay
            div.packages
                div.packagesContent

                    // Play Payments policy: no purchase UI on Android
                    subscribe-on-web(v-if="webOnly")

                    template(v-else)

                        // Title
                        title-component(:title="$t('payments.packages.title')" type="h1")

                        // Message
                        div.mb-4(v-html="$t('payments.packages.message')")

                        // Packages
                        package-component(
                            v-for="(item, key) in $t('payments.packages.packagesNoTrial')"
                            :key="`package-${key}`"
                            :item="item"
                            registrated
                        )
</template>

<script>
    import Layout from '../../Authorization/Layout';
    import Package from '~components/Package';
    import Separator from '~components/Separator';
    import SubscribeOnWeb from '~components/SubscribeOnWeb';
    import Title from '~components/Title';
    import { isAndroid } from '~services';

    export default {
        components: {
            Layout,
            packageComponent: Package,
            TitleComponent: Title,
            SeparatorComponent: Separator,
            SubscribeOnWeb
        },
        computed: {
            webOnly() {
                return isAndroid();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../assets/style/_variables.styl'

    .packagesWrapper
        position: absolute
        width: 100%
        min-height: 100%
        min-height: 100vh
        top: 0
        left: 0
        background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/payments/chill-image-min.png')
        background-size: cover
        background-position: center

    .packages
        display: flex
        align-items: center
        justify-content: center
        min-height: 100%
        min-height: 100vh

    .packagesContent
        width: 100%
        max-width: 540px
        padding: 16px
        border-radius: 10px
        background-color: $theme.primary

    .packagesOverlay
        min-height: 100%
        min-height: 100vh
        background: rgba(2, 35, 65, 0.6)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .packagesWrapper
            top: 16px
</style>
